import { getLog, pubkey_to_address } from "../../helpers/helpers.js";
import { waitForSharedWhatsOnChainConnector } from "../../shared/WhatsOnChainConnector.js";
import { hasNestedProperty } from "../../shared/helpers.js";


export const arrSum = arr => arr.reduce((a, b) => a + b, 0) // equivalent to Math.sum(arr)


export async function processOneTxData(tx_data, purse_address) {
    const function_id = "processOneBsvTxData: ";
    const log = getLog(function_id);
    if (!tx_data) throw new Error(function_id + "empty tx_data");
    if (!purse_address) throw new Error(function_id + "missing purse_address");

    const tx_hash = tx_data["tx_hash"];
    // const height = tx_data["height"]
    // fetch this txhash info via the shared WoC connector (handles rate limiting + retry)
    const wocConnector = await waitForSharedWhatsOnChainConnector();
    log("fetching tx info for tx_hash=", tx_hash);

    let tx_ins_outs = await wocConnector.fetchTxInfo(tx_hash);
    log("tx_ins_outs=", tx_ins_outs);

    // actions: receive, send
    let time = tx_ins_outs["time"] * 1000;
    let vins = tx_ins_outs["vin"];
    let vouts = tx_ins_outs["vout"];

    // if unconfirmed, there is no time
    if (Number.isNaN(time)) time = Date.now();

    // beware the route never returns voutDetails for vins, contrary to the web explorer's json
    let vins_filtered = vins.filter(e => !!e["scriptSig"]);
    let vouts_filtered = vouts.filter(e => !!e["scriptPubKey"] && !!!!e["scriptPubKey"]["addresses"]);

    // for vins we extract pubkeys from the sig and convert them to addresses
    let vins_pubkeys = vins_filtered.map(e => e["scriptSig"]["asm"]).map(e => e.split(' ').slice(-1)[0]);
    log("pubkeys = ", vins_pubkeys, "for tx_hash=", tx_hash);
    let vins_addresses = vins_pubkeys.map(e => pubkey_to_address(e));
    log("vins_addresses=", vins_addresses, "for tx_hash=", tx_hash);

    // TODO we should not only take [0] for the case of multisigs, but it's good enough for now
    let vouts_addresses = vouts_filtered.map(e => e["scriptPubKey"]["addresses"][0]);

    const is_op_return = hasNestedProperty(vouts[0], "scriptPubKey.opReturn");

    let we_are_in_vins = vins_addresses.includes(purse_address);
    let we_are_in_vouts = vouts_addresses.includes(purse_address);
    // true self-send: ALL inputs are from the purse AND ALL outputs (with
    // addresses) go back to the purse. A normal send also has the purse in
    // both vins and vouts (as change), so we can't rely on mere presence.
    const is_self_send = vins_addresses.length > 0
        && vouts_addresses.length > 0
        && vins_addresses.every(a => a === purse_address)
        && vouts_addresses.every(a => a === purse_address);
    log("is_op_return=", is_op_return, "we_are_in_vins=", we_are_in_vins, "we_are_in_vouts=", we_are_in_vouts, "is_self_send=", is_self_send, "for tx_hash=", tx_hash,
        "\n vins_addresses=", vins_addresses, "\n vouts_addresses=", vouts_addresses);

    /* if not op_return, we need to sum up the satoshis received vs sent
        the ideal solution would be to retrieve voutDetails for all vins
        but to simplify for now, we make this assumption:
            if we are not in vins => it's a receive
            if we are in vins => it's a send
        we also do a simplification for the value_bsv by only suming up the outs
    
    To simplify we sum all the outs values except the change utxo
       we simplify by only checking the [0] address but TODO handle multisig later
    */
    const external_addresses = vouts
        .filter(vout => hasNestedProperty(vout, "scriptPubKey.addresses"))
        .filter(vout => vout["scriptPubKey"]["addresses"][0] != purse_address);
    let value_bsv_external = arrSum(external_addresses.map(vout => vout.value));
    // rare case where we receive & there is no change utxo
    if (external_addresses.length == 0) value_bsv_external = vouts[0].value;

    const internal_addresses = vouts
        .filter(vout => hasNestedProperty(vout, "scriptPubKey.addresses"))
        .filter(vout => vout["scriptPubKey"]["addresses"][0] == purse_address);
    let value_bsv_internal = arrSum(internal_addresses.map(vout => vout.value));
    // rare case where we send with no change utxo
    if (internal_addresses.length == 0) value_bsv_internal = vouts[0].value;

    // had bug with more decimals showing up, so let's limit to 8
    value_bsv_external = parseFloat(value_bsv_external.toFixed(8));
    value_bsv_internal = parseFloat(value_bsv_internal.toFixed(8));

    // another simplification: we take only the first address that isn't our own purse
    // TODO fix when there is no change address we find nothing (bc we should look at inputs)
    const first_external_address = vouts
        .filter(vout => hasNestedProperty(vout, "scriptPubKey.addresses"))
        .map(vout => vout["scriptPubKey"]["addresses"][0])
        .find(address => address != purse_address);

    let res = {};
    if (is_op_return) { // op_return tx
        res = {
            value_bsv: value_bsv_external,
            time: time,
            // sender: purse_address, receiver: "---",
            action: "token_tx",
            tx_hash: tx_hash,
        };
    }
    else {
        if (is_self_send) {
            // self-send: ALL inputs from purse AND ALL outputs back to purse.
            // The amount shown should be only the FIRST output (the rest are
            // change/splits), not the sum of all internal outputs.
            const self_send_value = internal_addresses.length > 0
                ? internal_addresses[0].value
                : value_bsv_internal;
            res = {
                value_bsv: parseFloat(self_send_value.toFixed(8)),
                time: time,
                action: "send_to_yourself",
                tx_hash: tx_hash,
            };
        }
        else if (!we_are_in_vins) { // assume receive
            res = {
                value_bsv: value_bsv_internal,
                time: time,
                sender: first_external_address,
                // receiver: "???",
                action: "receive",
                tx_hash: tx_hash,
            };
        }
        else { // assume send
            res = {
                value_bsv: value_bsv_external,
                time: time,
                // sender: "???",
                receiver: first_external_address,
                action: "send",
                tx_hash: tx_hash,
            };
        }
    }
    return res;
}
